import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { AsyncPipe } from '@angular/common';
import { Ciclo } from '@app/shared/models/ciclo';
import { DropDownDirective } from '@sigepe/dsgov-theme';
import { MessageFeedbackComponent } from '@app/shared/components/message-feedback/message-feedback.component';
import { Observable } from 'rxjs';
import { SelectModule } from 'primeng/select';

@Component({
	selector: 'sgp-select-ciclo',
	standalone: true,
	imports: [ReactiveFormsModule, AsyncPipe, SelectModule, DropDownDirective, MessageFeedbackComponent],
	templateUrl: './select-ciclo.component.html'
})
export class SelectCicloComponent {
	@Input() control!: FormControl;
	@Input() options$?: Observable<Ciclo[]>;
	@Input() label = 'Ciclo:';
	@Input() showError = false;
	@Input() filter = true;
	@Input() placeholder = 'Selecione o ciclo';
	@Output() changed = new EventEmitter<Ciclo | undefined>();
}
